import { ClearAll } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClearSelectedEntitiesButtonProps } from './types';
import { useContext } from 'react';
import { MapContext } from 'components/maps/MapContext';

const ClearSelectedEntitiesButton: React.FunctionComponent<ClearSelectedEntitiesButtonProps> = (
  _props
) => {
  const { t } = useTranslation(['app']);
  const { selectedEntities, removeAllEntities } = useContext(MapContext);
  const renderClearSelectedEntitiesButton = () => {
    return (
      <Tooltip title={t('removeAllSelections')}>
        <span>
          <IconButton onClick={() => removeAllEntities()} disabled={selectedEntities.size === 0}>
            <ClearAll fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>
    );
  };

  return renderClearSelectedEntitiesButton();
};

export default ClearSelectedEntitiesButton;
